import {
  ViewLegendComponentProps,
  getLegendRows,
  getLegendTitles,
} from '@ardoq/timeline2024';

import { ViewLegendContainer } from '@ardoq/graph';
import {
  ViewLegend,
  getActiveConditionalFormattingForLegend,
} from '@ardoq/view-legend';

import { getActiveDiffMode } from 'scope/activeDiffMode$';
import { HeightOffset } from 'views/viewLegend/useViewLegendSubscription';
import { isInScopeDiffMode } from '../../scope/scopeDiff';
import { i18nLocale$ } from 'streams/i18nLocale$';
import type { WithI18nLocale } from '@ardoq/i18n';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { getViewLegendLabels } from 'viewLegend/getViewLegendLabels';

/**
 * This components depends on the rendering data state that is internal to package,
 * but it is located in ardoq-front. So this ugly hack is a way to move forward for now.
 */
const ViewLegendComponentInner = ({
  legendComponentTypes,
  isLegendActive,
  orderedSelectedMilestoneFields,
  orderedSelectedPhaseFields,
  isNewConditionalFormatting,
  users,
  i18nLocale,
}: ViewLegendComponentProps & WithI18nLocale) => {
  const legendTitles = getLegendTitles(i18nLocale);
  return (
    <HeightOffset>
      {heightOffset => (
        <ViewLegendContainer
          heightOffset={heightOffset}
          visible={isLegendActive}
        >
          <ViewLegend
            componentTypes={legendComponentTypes}
            activeConditionalFormatting={getActiveConditionalFormattingForLegend(
              i18nLocale,
              undefined,
              isNewConditionalFormatting,
              users
            )}
            additionalRows={getLegendRows({
              orderedSelectedMilestoneFields,
              orderedSelectedPhaseFields,
              phasesTitle: legendTitles.phasesTitle,
              milestonesTitle: legendTitles.milestonesTitle,
            })}
            activeDiffMode={isInScopeDiffMode() ? getActiveDiffMode() : null}
            labels={getViewLegendLabels(i18nLocale)}
          />
        </ViewLegendContainer>
      )}
    </HeightOffset>
  );
};

const i18nLocaleProps$ = i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })));

export const ViewLegendComponent = connect(
  ViewLegendComponentInner,
  i18nLocaleProps$
);
